import styled from 'styled-components';
/* This empty styled component still exists because it is targeted/styled in navigation-flyout-row */
export const NavigationFlyoutColumnElement = styled.div ``;
